export const allLibraries = ['drawing', 'places', 'visualization'] as ['drawing', 'places', 'visualization'];
